import { surfaceCopy, type SurfaceState } from '../lib/surface-state';

export function SurfaceBanner({ state, empty }: { state: SurfaceState; empty?: string }) {
  if (state === 'default') return null;
  return (
    <div className="notice" data-surface-state={state} role={state === 'error' ? 'alert' : 'status'}>
      <span className="notice-mark">{state === 'error' ? '!' : 'i'}</span>
      <span>{state === 'empty' && empty ? empty : surfaceCopy[state]}</span>
    </div>
  );
}
